export default __webpack_public_path__ + "static/media/bestseller4.5d22adcc.png";